import React, { Component } from 'react'
import "./Loader.css";



export default class Loader extends Component {
    constructor(props){
        super(props);
        this.state = {
            word: "Loading"
        }
    }

    componentDidMount()
    {
        var that = this; 
        that.count = 0;
        
        this.timer = setInterval(() => {
            that.setState({word : "Loading " + '. '.repeat(that.count)});
            that.count += 1;
            if(that.count === 4)
            {
                that.count = 0;
            }
        }, 450);

    }

    componentWillUnmount()
    {
        clearInterval(this.timer);
    }

    render() {
        var id = (this.props.loaded) ? "loader-hidden" : "loader";
        return (
            <div id = {id}>
                <h1 className = "Loader-text">
                    {this.state.word}
                </h1>
            </div>
        )
    }
}
